module.exports = __webpack_public_path__ + "static/permissions-assignments-a6bc0abbf4f9d278d542059da8e8fb17.png";